import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PortfolioCard } from './sections';
import onscriptLogo from '../images/cases/onscript-logo.png';

const FeaturedWork = () => {
  const navigate = useNavigate();

  const projects = [
    {
      title: "OnScript.ai",
      logo: onscriptLogo,
      summary:
        "Boost agent performance and maximize ROI with AI-powered speech analytics that scores every call with precision and consistency.",
      tags: ["Speech Analytics", "QA Automation", "Contact Center AI"],
      stats: [
        { label: "QA coverage", value: "100% calls evaluated" },
        { label: "Coaching speed", value: "Faster agent feedback" },
      ],
      href: "/portfolio/onscript-ai",
      externalHref: "https://onscript.ai",
    },
  ];

  return (
    <div className="relative overflow-hidden py-12 md:py-24 mb-12 md:mb-24">
      <div className="container-custom space-y-10">
        {/* Header */}
        <div className="max-w-3xl">
          <p className="text-[#456EF2] font-montserrat font-semibold text-sm uppercase tracking-wide mb-3">
            Case studies
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-slate-900">Featured work</h2>
          <p className="text-lg text-slate-600">
            See how we deliver measurable results with production-grade AI systems and thoughtful product design.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 gap-8">
          {projects.map((project) => (
            <PortfolioCard key={project.title} {...project} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeaturedWork;
